// Fallback S3 path so an upload that forgets to set `path` lands in a known
// folder instead of the bucket root.
export const FILESTACK_DEFAULT_PATH = '/media/images/uploads/'

const sanitizeFilename = name => name.replace(/[^\w\.]/g, '')

const filestackTransformAndUpload = (client, apiKey, file, storeOptions, {
  TransformClass = FilestackTransform,
} = {}) => {
  const sanitizedName = sanitizeFilename(file.name)
  const opts = { ...storeOptions, path: storeOptions?.path || FILESTACK_DEFAULT_PATH }

  if (file.type === 'image/gif') {
    const sanitized = new File([file], sanitizedName, { type: file.type })
    return client.upload(sanitized, {}, opts)
  }

  const tr = new TransformClass(apiKey)
  tr.setConfigKey('output.blob', true)
  return tr.open(file).then(blob => {
    if (!blob) return
    return client.upload(new File([blob], sanitizedName, { type: blob.type }), {}, opts)
  })
}

export default filestackTransformAndUpload
